import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as BaseLink } from 'react-router-dom';
import { useParams } from 'react-router';
import { Link } from '@material-ui/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { ROUTES } from '../../core/router/routes';
import { CategoryParams } from '../../features/category/model/categoryModel';
import { useGetCategoryTreesQuery, useGetCategoriesQuery } from '../../features/category/api/categoryApi';
import './moreCategoryInCategory.scss';

interface MoreCategoryInCategoryProps {
  categoryId: string;
}

const MoreCategoryInCategory: FC<MoreCategoryInCategoryProps> = (props) => {
  const params = useParams<CategoryParams>();
  const { t } = useTranslation();
  const { data: categoryTrees, isSuccess } = useGetCategoryTreesQuery({
    id: props.categoryId,
  });
  const { subcategoryIds, isSuccess: isSuccessPublishedCategory } = useGetCategoriesQuery(
    {},
    {
      selectFromResult: (result) => {
        return {
          ...result,
          subcategoryIds: result.data?.map((category) => category.id),
        };
      },
    },
  );

  const categoryLimit = 5;

  let currentCategory;
  let limitedCategory;
  let moreCategoriesAvailable;

  if (isSuccess && isSuccessPublishedCategory) {
    if (categoryTrees.length > 1) {
      currentCategory = categoryTrees[categoryTrees.length - 2];
      const publishedCategoryInCategoryWithoutDisplayed = currentCategory?.subcategories.filter(
        (category) => category.id !== parseInt(params.id!) && subcategoryIds?.includes(category.id),
      );
      limitedCategory = publishedCategoryInCategoryWithoutDisplayed.slice(0, categoryLimit);
      moreCategoriesAvailable = publishedCategoryInCategoryWithoutDisplayed.length > categoryLimit;
    }
  }

  return (
    <>
      {isSuccess && limitedCategory && limitedCategory?.length ? (
        <section className="MoreCategoryInCategory-Section">
          <h3>
            {t('more_category_in_category.title')} {currentCategory?.name}
          </h3>
          <ul>
            {limitedCategory?.map(({ name, id }) => {
              return (
                <li key={id}>
                  <Link to={ROUTES.CATEGORY.ARTICLE.replace(':id', id as unknown as string)} component={BaseLink}>
                    {name}
                  </Link>
                </li>
              );
            })}
            {moreCategoriesAvailable && (
              <li>
                <Link
                  to={ROUTES.CATEGORY.ARTICLE.replace(':id', currentCategory?.id as unknown as string)}
                  component={BaseLink}
                >
                  {t('more_category_in_category.other_categories_from_categories')} {currentCategory?.name}
                  <FontAwesomeIcon icon={faChevronRight as IconProp} size={'xs'} />
                </Link>
              </li>
            )}
          </ul>
        </section>
      ) : (
        <></>
      )}
    </>
  );
};

export default MoreCategoryInCategory;
